// removed by extract-text-webpack-plugin
module.exports = {"background":"Background-m__background___1IvOn"};


//////////////////
// WEBPACK FOOTER
// ./components/background/Background.m.sass
// module id = KLmD
// module chunks = 0